"use client";

import { c as _c } from "react/compiler-runtime";
import DropPfp from "@/components/drops/create/utils/DropPfp";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
import { useIdentity } from "@/hooks/useIdentity";
import { useIdentityBalance } from "@/hooks/useIdentityBalance";
import UserCICTypeIcon from "../user-cic-type/UserCICTypeIcon";
import UserLevel from "../level/UserLevel";
import { CLASSIFICATIONS, CicStatement } from "@/entities/IProfile";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import { useEffect, useState } from "react";
export default function UserProfileTooltip(t0) {
  const $ = _c(84);
  const {
    user
  } = t0;
  let t1;
  if ($[0] !== user) {
    t1 = {
      handleOrWallet: user,
      initialProfile: null
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  const t2 = profile?.consolidation_key ?? null;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      consolidationKey: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: balance
  } = useIdentityBalance(t3);
  let t4;
  if ($[4] !== user) {
    t4 = user.toLowerCase();
    $[4] = user;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = [QueryKey.PROFILE_CIC_STATEMENTS, t4];
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== user) {
    t6 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/cic/statements`
    });
    $[8] = user;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !!user && !!profile?.handle;
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const {
    data: statements
  } = useQuery(t8);
  const [aboutStatement, setAboutStatement] = useState(null);
  let t10;
  let t9;
  if ($[14] !== statements) {
    t9 = () => {
      const about = statements?.find(_temp);
      setAboutStatement(about ?? null);
    };
    t10 = [statements];
    $[14] = statements;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  const description = profile?.classification ? CLASSIFICATIONS[profile.classification]?.title : null;
  const t11 = profile?.pfp;
  let t12;
  if ($[17] !== t11) {
    t12 = <div className="tw-flex tw-justify-start"><div className="tw-flex-shrink-0"><DropPfp pfpUrl={t11} /></div></div>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = profile?.handle ?? profile?.display;
  let t14;
  if ($[19] !== t13) {
    t14 = <span className="tw-text-base tw-font-bold tw-text-iron-50 tw-truncate tw-max-w-[180px]">{t13}</span>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== profile) {
    t15 = profile && <div className="tw-h-5 tw-w-5"><UserCICTypeIcon cic={profile.cic} /></div>;
    $[21] = profile;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2">{t14}{t15}</div>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== description) {
    t17 = description && <p className="tw-text-xs tw-text-iron-400 tw-mb-0">{description}</p>;
    $[26] = description;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== profile) {
    t18 = profile && <div className="tw-mt-1.5"><UserLevel level={profile.level} size="xs" /></div>;
    $[28] = profile;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t16 || $[31] !== t17 || $[32] !== t18) {
    t19 = <div className="tw-flex tw-flex-col">{t16}{t17}{t18}</div>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t12 || $[35] !== t19) {
    t20 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t12}{t19}</div>;
    $[34] = t12;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== aboutStatement) {
    t21 = aboutStatement && <p className="tw-text-sm tw-text-iron-200 tw-line-clamp-6 tw-mb-0 tw-mt-4">{aboutStatement.statement_value}</p>;
    $[37] = aboutStatement;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  const t22 = profile?.tdh ?? 0;
  let t23;
  if ($[39] !== t22) {
    t23 = formatNumberWithCommasOrDash(t22);
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t23) {
    t24 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t23}</span>;
    $[41] = t23;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <span className="tw-text-sm tw-text-iron-400">TDH</span>;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t24) {
    t26 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t24}{t25}</div>;
    $[44] = t24;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  const t27 = profile?.tdh_rate ?? 0;
  let t28;
  if ($[46] !== t27) {
    t28 = formatNumberWithCommasOrDash(t27);
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== t28) {
    t29 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t28}</span>;
    $[48] = t28;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span className="tw-text-sm tw-text-iron-400">TDH Rate</span>;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t29) {
    t31 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t29}{t30}</div>;
    $[51] = t29;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  const t32 = profile?.rep ?? 0;
  let t33;
  if ($[53] !== t32) {
    t33 = formatNumberWithCommasOrDash(t32);
    $[53] = t32;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t33) {
    t34 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t33}</span>;
    $[55] = t33;
    $[56] = t34;
  } else {
    t34 = $[56];
  }
  let t35;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <span className="tw-text-sm tw-text-iron-400">REP</span>;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== t34) {
    t36 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t34}{t35}</div>;
    $[58] = t34;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  const t37 = profile?.cic ?? 0;
  let t38;
  if ($[60] !== t37) {
    t38 = formatNumberWithCommasOrDash(t37);
    $[60] = t37;
    $[61] = t38;
  } else {
    t38 = $[61];
  }
  let t39;
  if ($[62] !== t38) {
    t39 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t38}</span>;
    $[62] = t38;
    $[63] = t39;
  } else {
    t39 = $[63];
  }
  let t40;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <span className="tw-text-sm tw-text-iron-400">NIC</span>;
    $[64] = t40;
  } else {
    t40 = $[64];
  }
  let t41;
  if ($[65] !== t39) {
    t41 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t39}{t40}</div>;
    $[65] = t39;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  const t42 = balance?.total_balance ?? 0;
  let t43;
  if ($[67] !== t42) {
    t43 = formatNumberWithCommasOrDash(t42);
    $[67] = t42;
    $[68] = t43;
  } else {
    t43 = $[68];
  }
  let t44;
  if ($[69] !== t43) {
    t44 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t43}</span>;
    $[69] = t43;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  let t45;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <span className="tw-text-sm tw-text-iron-400">Balance</span>;
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  let t46;
  if ($[72] !== t44) {
    t46 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t44}{t45}</div>;
    $[72] = t44;
    $[73] = t46;
  } else {
    t46 = $[73];
  }
  let t47;
  if ($[74] !== t26 || $[75] !== t31 || $[76] !== t36 || $[77] !== t41 || $[78] !== t46) {
    t47 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1.5 tw-mt-4">{t26}{t31}{t36}{t41}{t46}</div>;
    $[74] = t26;
    $[75] = t31;
    $[76] = t36;
    $[77] = t41;
    $[78] = t46;
    $[79] = t47;
  } else {
    t47 = $[79];
  }
  let t48;
  if ($[80] !== t20 || $[81] !== t21 || $[82] !== t47) {
    t48 = <div className="tailwind-scope tw-bg-iron-950 tw-min-w-[280px] tw-max-w-[320px]">{t20}{t21}{t47}</div>;
    $[80] = t20;
    $[81] = t21;
    $[82] = t47;
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  return t48;
}
function _temp(statement) {
  return statement.statement_type === STATEMENT_TYPE.BIO && statement.statement_group === STATEMENT_GROUP.GENERAL;
}